var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n  <div class=\"modal-dialog modal-sm\" style=\" margin-left: 100px; top: 300px; width: calc(100% - 200px); z-index:10001\" role=\"document\">\n\n  <div class=\"loader\" style=\"  border: 16px solid #99b5c9 ;\n  border-radius: 50%;\n  margin-left: 50%;\n  border-top: 16px solid #f3f3f3;\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite; /* Safari */\n  animation: spin 2s linear infinite;\"></div>\n</div>\n\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/download/views/WaitingResponseView.hbs
// module id = 2048
// module chunks = 0